import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const UpcomingCourses = () => {
  const courses = [
    {
      title: 'Foundations of AI in the Workplace',
      dates: 'October 15, 2024',
      method: 'Live Virtual',
      location: 'Online (EST)',
      instructor: 'Linda Boes',
      schedule: '08:00 - 12:00',
      price: '$295 USD',
      seats: 15,
      deadline: 'October 1, 2024',
      prerequisites: 'None',
      category: 'AI & Future Workforce',
      image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=800&auto=format&fit=crop'
    },
    {
      title: 'Hazardous Materials Incident Commander',
      dates: 'November 5-6, 2024',
      method: 'Onsite / Classroom',
      location: 'Fort Wayne, IN',
      instructor: 'Terry Boes',
      schedule: '08:00 - 17:00 Daily',
      price: '$695 USD',
      seats: 5,
      deadline: 'October 25, 2024',
      prerequisites: 'Hazmat Operations',
      category: 'Technical & Hazmat',
      image: 'https://images.unsplash.com/photo-1584036561566-baf8f5f1b144?q=80&w=800&auto=format&fit=crop'
    }
  ];

  return (
    <div className="w-full bg-brand-light min-h-screen">
      <PageHeader 
        title="Upcoming Scheduled Courses" 
        description="Register for confirmed public and virtual training sessions." 
      />
      
      <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="space-y-8">
          {courses.map((course, i) => (
            <div key={i} className="bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col lg:flex-row">
              
              <div className="lg:w-64 h-48 lg:h-auto shrink-0 relative">
                <img src={course.image} alt={course.title} className="w-full h-full object-cover grayscale opacity-80 mix-blend-multiply" />
                <div className="absolute inset-0 bg-brand-navy/20"></div>
                <div className="absolute top-4 left-4 bg-brand-navy text-white px-3 py-1 rounded-md text-xs font-bold shadow-sm">
                  {course.method}
                </div>
              </div>

              <div className="flex-grow p-6 md:p-8">
                <div className="text-xs font-bold text-brand-green uppercase tracking-wider mb-2">{course.category}</div>
                <h3 className="text-2xl font-bold text-brand-navy mb-6">{course.title}</h3>
                
                <div className="grid sm:grid-cols-2 gap-y-4 gap-x-8 text-sm text-slate-700">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-slate-50 flex items-center justify-center text-brand-navy">
                      <SafeIcon icon={FiIcons.FiCalendar} />
                    </div>
                    <span className="font-semibold">{course.dates}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-slate-50 flex items-center justify-center text-brand-navy">
                      <SafeIcon icon={FiIcons.FiMapPin} />
                    </div>
                    <span>{course.location}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-slate-50 flex items-center justify-center text-brand-navy">
                      <SafeIcon icon={FiIcons.FiClock} />
                    </div>
                    <span>{course.schedule}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-slate-50 flex items-center justify-center text-brand-navy">
                      <SafeIcon icon={FiIcons.FiUser} />
                    </div>
                    <span>Instructor: {course.instructor}</span>
                  </div>
                  <div className="flex items-center gap-3 text-brand-navy font-semibold sm:col-span-2 mt-2">
                    <SafeIcon icon={FiIcons.FiAlertCircle} className="text-brand-green" />
                    <span>Registration Deadline: {course.deadline}</span>
                  </div>
                  <div className="flex items-center gap-3 text-slate-600 font-medium sm:col-span-2">
                    <SafeIcon icon={FiIcons.FiInfo} />
                    <span>Prerequisites: {course.prerequisites}</span>
                  </div>
                </div>
              </div>

              <div className="lg:w-72 shrink-0 bg-slate-50 p-6 md:p-8 border-t lg:border-t-0 lg:border-l border-slate-200 flex flex-col justify-center">
                <div className="text-3xl font-black text-brand-navy mb-1 text-center">{course.price}</div>
                <div className="text-xs text-brand-green font-bold uppercase tracking-wide mb-6 text-center">{course.seats} Seats Available</div>
                
                <div className="w-full space-y-3">
                  <Link to="/contact" className="w-full py-3 bg-brand-green text-white rounded-lg text-sm font-bold hover:bg-green-600 transition-colors shadow-sm flex items-center justify-center">
                    Register Now
                  </Link>
                  <Link to="/contact" className="w-full py-3 bg-white border border-slate-300 text-slate-700 rounded-lg text-sm font-bold hover:bg-slate-50 transition-colors flex items-center justify-center">
                    View Details
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default UpcomingCourses;